module.exports = __webpack_public_path__ + "workspace/static/img/eagle.d0503c5.png";